import { useState, useEffect } from 'react';
import { Button, Input } from 'reactstrap';
import { Label, Row, Col } from 'reactstrap';
import { useSelector } from 'react-redux';
import Select from '../../../components/Select/Select';
import countryList from 'react-select-country-list';
import './onBoardModalStyle.scss';
import { BILLING_FREQUENCY, CURRENCY, ENGAGEMENT_OPTIONS } from '../../../constants/common';
import { billingChannelOptions } from '../../Projects/components/CustomStyleSelect';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

export const BillingDetails = ({
  stepper,
  active,
  setActive,
  formData,
  updateFormData,
  onBoardingRecord,
  typeModal,
}) => {
  const [exactClientNameError, setExactClientNameError] = useState('');
  const [errorRegion, setErrorRegion] = useState('');
  const [errorCompanyName, setErrorCompanyName] = useState('');
  const [errorClientEmail, setErrorClientEmail] = useState('');
  const [errorProjectCost, setErrorProjectCost] = useState('');
  const [errorCurrencyOther, setErrorCurrencyOther] = useState('');
  const [errorBillingProfile, setErrorBillingProfile] = useState('');
  const [errorTotalHours, setErrorTotalHours] = useState('');
  const [showCurrencyRow, setShowCurrencyRow] = useState(false);

  const [multiSelectCountry, setMultiSelectCountry] = useState([]);
  const onBoardingProjectType = useSelector((state) => {
    const onBoardingProjects = state?.onBoardingProject?.onBoardingProjects?.onBoardedProjects;
    const projects = state?.projects?.projects;

    const matchingProjectType = onBoardingProjects || projects?.find((project) => project?.id === formData?.onBoardingId);

    return matchingProjectType?.projectType || null;
  });

  const onBoardingProjectDate = useSelector((state) => {
    const matchingProject =
      state?.onBoardingProject?.onBoardingProjects?.onBoardedProjects?.find((project) => project?.id === formData?.onBoardingId) ||
      state?.projects?.projects?.find((project) => project?.id === formData?.onBoardingId);

    return matchingProject?.createdAt ? new Date(matchingProject?.createdAt).toISOString().split('T')[0] : null;
  });
  const [billingFrequencyOptions, setBillingFrequencyOptions] = useState(BILLING_FREQUENCY);
  const billingChannels = useSelector((state) => state?.billingChannelReducer?.allBillingChannels)

  const billingOptions = billingChannels?.map((item) => { return { id: item?.id, value: item?.slug, label: item?.name } })
  const sortedOptions = [
    ...billingOptions?.filter((option) => option?.slug !== 'OTHER').sort((a, b) => a?.name?.localeCompare(b?.name)),
    { value: 'OTHER', label: 'Other' },
  ];

  useEffect(() => {
    if (onBoardingRecord === null) updateFormData({ ...formData, ['currency']: 'United States Dollar' });
  }, []);

  useEffect(() => {
    if (formData?.country) {
      const makeCountries = formData?.country?.split(',').map((item) => {
        return { value: item, label: item };
      });
      setMultiSelectCountry(makeCountries);
    }
  }, [formData]);

  const validateEmail = (event) => {
    const { value } = event.target;
    const reg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (value && reg?.test(value) === false) {
      setErrorClientEmail(<span className="select-error-msg">Email should be valid!</span>);
    }
  };

  let requiredFields = [
    // 'projectCost',
    'billingPlateform',
    'exactClientName',
    'country',
    // 'augmentation',
  ];
  if (formData?.currency === 'Other') {
    requiredFields?.push('currencyOther');
  }
  if (formData?.serviceMode === 'YET_TO_BE_DECIDED') {
    requiredFields?.push('augmentation')
  }
  if (formData?.augmentation === 'FIXED_GIGZ' || formData?.serviceMode === 'FIXED_GIGZ') {
    requiredFields?.push('totalEstimatedHours');
  }
  if (formData && [('UPWORK_PROFILE', 'PAYONEER_ACCOUNT', 'OTHER')].includes(formData['billingPlateform'])) {
    requiredFields?.push('billingProfile');
  }
  const isDisabled = errorCurrencyOther || errorClientEmail || requiredFields?.some((field) => !formData || !formData[field]);
  useEffect(() => {
    if (formData?.engagement) {
      if (formData.engagement === 'MONTHLY') {
        updateFormData({ ...formData, billingFrequency: 'MONTHLY' });
        setBillingFrequencyOptions(BILLING_FREQUENCY);
      } else if (formData.engagement === 'FIXED_GIGZ') {
        updateFormData({ ...formData, billingFrequency: 'MILESTONE' });
        setBillingFrequencyOptions([{ value: 'MILESTONE', label: 'Milestone' }]);
      }
    }
  }, [formData?.engagement]);
  // useEffect(() => {
  //   if (formData?.augmentation) {
  //     if (formData.augmentation === 'MONTHLY') {
  //       updateFormData({ ...formData, billingFrequency: 'MONTHLY' });
  //     } else if (formData.augmentation === 'HOURLY') {
  //       updateFormData({ ...formData, billingFrequency: 'WEEKLY' });
  //     }
  //   }
  //   if(formData?.serviceMode) {
  //     if (formData?.serviceMode === 'FIXED_GIGZ') {
  //       updateFormData({ ...formData, billingFrequency: 'MILESTONE' });
  //     }
  //   }
  // }, [formData?.augmentation, formData?.serviceMode]);

  const handleEngagementChange = (selectedOption) => {
    updateFormData({
      ...formData,
      augmentation: selectedOption.value,
      billingFrequency:
        selectedOption.value === 'FIXED_GIGZ'
          ? 'MILESTONE'
          : selectedOption.value === 'MONTHLY'
            ? 'MONTHLY'
            : selectedOption.value === 'HOURLY'
              ? 'WEEKLY'
              : '',
      totalEstimatedHours: selectedOption?.value === 'FIXED_GIGZ' ? null : formData.totalEstimatedHours
    });
  };

  const defaultCurrency = CURRENCY && CURRENCY?.find((el) => el.value === formData?.currency);
  return (
    <>
      <div className={typeModal === 'manage' ? '' : 'container'}>
        <Row className="row-projects">
          <Col xs="12" sm="6" md="6" lg="6">
            <Label>
              Client Name <span className="spanSteric">*</span>
            </Label>
            <Input
              name="exactClientName"
              className={exactClientNameError ? 'select-error-border' : ''}
              type="text"
              maxLength={40}
              value={formData?.exactClientName}
              autoComplete="off"
              placeholder={'Type here'}
              onChange={(event) => {
                const { name, value } = event.target;
                if (value.trim().length > 40) {
                  setExactClientNameError(<span className="select-error-msg">Maximum 40/40 characters are allowed!</span>);
                } else if (/^\s/.test(value)) {
                  updateFormData({ ...formData, [name]: value.trimLeft() });
                  setExactClientNameError(<span className="select-error-msg">Cannot start with a space!</span>);
                } else {
                  updateFormData({ ...formData, [name]: value });
                  setExactClientNameError('');
                }
              }}
            />
            {exactClientNameError && <span className="select-error-msg">{exactClientNameError}</span>}
          </Col>
          <Col xs="12" sm="6" md="6" lg="6">
            <Label>
              Client Region <span className="spanSteric">*</span>
            </Label>
            <Select
              sortBy="label"
              sortingOrder="ascending"
              placeholder={'Select region'}
              options={countryList()
                .getData()
                .map((el) => {
                  return { value: el.label, label: el.label };
                })}
              maxMenuHeight={120}
              value={multiSelectCountry}
              onChange={(selectedOption) => {
                const val = selectedOption ? selectedOption.label : '';
                updateFormData({ ...formData, country: val });
                setMultiSelectCountry(selectedOption ? [selectedOption] : []);
                setErrorRegion('');
              }}
              hideSelectedOptions={true}
            />
            {errorRegion && <span className="select-error-msg">{errorRegion}</span>}
          </Col>
        </Row>

        <Row className="row-projects">
          <Col xs="12" sm={formData?.augmentation === 'FIXED_GIGZ' ? "4" : "6"}>
            <Label>
              Engagement
              <span className="spanSteric">*</span>
            </Label>
            <Select
              name="engagement"
              options={ENGAGEMENT_OPTIONS}
              placeholder={'Select engagement'}
              // value={ENGAGEMENT_OPTIONS.find((opt) => opt.value === formData?.augmentation)}
              value={ENGAGEMENT_OPTIONS.find((opt) => opt.value === formData?.augmentation)}
              // value={formData?.serviceMode === "FIXED_GIGZ" ? ENGAGEMENT_OPTIONS.find((opt) => opt.value === formData?.serviceMode) : ENGAGEMENT_OPTIONS.find((opt) => opt.value === formData?.augmentation)}
              onChange={handleEngagementChange}
              maxMenuHeight={120}
            // isDisabled={formData?.serviceMode !== 'YET_TO_BE_DECIDED'}
            />
          </Col>

          {
            (formData?.augmentation === 'FIXED_GIGZ') &&
            <Col xs="12" sm="4">
              <Label>Estimated Hours</Label>
              <span className="spanSteric">*</span>
              <Input
                name="totalEstimatedHours"
                className={errorTotalHours ? 'select-error-border' : ''}
                type="text"
                maxLength={51}
                value={formData?.totalEstimatedHours ? formData?.totalEstimatedHours : null}
                autoComplete="off"
                placeholder={'Type here'}
                onChange={(event) => {
                  const { name, value } = event.target;
                  if (value?.length === 10) {
                    setErrorTotalHours(<span className="select-error-msg">Maximum 10 numbers are allowed!</span>);
                  } else if (/^\s/.test(value)) {
                    updateFormData({ ...formData, [name]: value.trimLeft() });
                    setErrorTotalHours(<span className="select-error-msg">Cannot start with a space!</span>);
                  } else {
                    updateFormData({ ...formData, [name]: value });
                    setErrorTotalHours('');
                  }
                }}
                onKeyPress={(event) => {
                  if (/[^0-9]/.test(event.key)) {
                    setErrorTotalHours(<span className="select-error-msg">Only numbers are allowed!</span>);
                    event.preventDefault();
                  }
                }}
              />
              {errorTotalHours && <span className="select-error-msg">{errorTotalHours}</span>}
            </Col>
          }

          <Col xs="12" sm={formData?.augmentation === 'FIXED_GIGZ' ? "4" : "6"}>
            <Label>
              Billing Cycle
              <span className="spanSteric">*</span>
            </Label>
            <Select
              name="billingFrequency"
              options={BILLING_FREQUENCY}
              placeholder={'Select billing cycle'}
              value={
                formData?.augmentation === 'FIXED_GIGZ' || formData?.Engagement === 'FIXED_GIGZ'
                  ? { label: 'Milestone', value: 'MILESTONE' }
                  : formData?.augmentation === 'MONTHLY' || formData?.Engagement === 'MONTHLY'
                    ? { label: 'Monthly', value: 'MONTHLY' }
                    : formData?.augmentation === 'HOURLY' || formData?.Engagement === 'HOURLY'
                      ? BILLING_FREQUENCY.find((opt) => opt.value === formData?.billingFrequency)
                      : ''
              }
              onChange={(selectedOption) => updateFormData({ ...formData, billingFrequency: selectedOption.value })}
              isDisabled={formData?.augmentation === 'FIXED_GIGZ' || formData?.augmentation === 'MONTHLY'}
              maxMenuHeight={120}
            />
          </Col>
        </Row>
        <Row className="row-projects">
          {/* <Col xs={formData?.currency === 'Other' ? '12' : '12'} sm={formData?.currency === 'Other' ? '4' : '6'} md="6" lg="6">
            <Label>
              {' '}
              Billing Rates/ Total Project Cost
              <span className="spanSteric">*</span>
            </Label>
            <Input
              name="projectCost"
              className={errorProjectCost ? 'select-error-border' : ''}
              type="text"
              maxLength={41}
              value={formData?.projectCost}
              autoComplete="off"
              placeholder={'Type here'}
              onChange={(event) => {
                const { name, value } = event.target;
                if (value.length === 41) {
                  setErrorProjectCost(<span className="select-error-msg">Maximum 40/40 characters are allowed!</span>);
                } else if (/^\s/.test(value)) {
                  updateFormData({ ...formData, [name]: value.trimLeft() });
                  setErrorProjectCost(<span className="select-error-msg">Cannot start with a space!</span>);
                } else {
                  updateFormData({ ...formData, [name]: value });
                  setErrorProjectCost('');
                }
              }}
              onKeyPress={(event) => {
                if (/[^0-9]/.test(event.key)) {
                  setErrorProjectCost(<span className="select-error-msg">Only numbers are allowed!</span>);
                  event.preventDefault();
                }
              }}
            />
            {errorProjectCost && <span className="select-error-msg">{errorProjectCost}</span>}
          </Col> */}
          <Col xs={formData?.currency === 'Other' ? '12' : '12'} sm={formData?.currency === 'Other' ? '4' : '6'} md="6" lg="6">
            <Label>
              Currency <span className="spanSteric">*</span>
            </Label>
            <Select
              name="currency"
              options={CURRENCY}
              placeholder={'Select currency'}
              value={defaultCurrency && { value: defaultCurrency.value, label: defaultCurrency.label }}
              onChange={(event) => {
                if (event && event.value) {
                  const { value } = event;
                  if (value === 'Other') {
                    setShowCurrencyRow(true);
                    // setErrorCurrencyOther(' ');
                  } else {
                    setShowCurrencyRow(false);
                    formData.currencyOther = null;
                    setErrorCurrencyOther('');
                  }
                  updateFormData({ ...formData, ['currency']: value });
                }
              }}
              maxMenuHeight={120}
            />
          </Col>
          {(showCurrencyRow || formData?.currency === 'Other') && (
            <Col xs="12" sm="6">
              <Label>
                Currency if selected other <span className="spanSteric">*</span>
              </Label>
              <Input
                name="currencyOther"
                className={errorCurrencyOther ? 'select-error-border' : ''}
                type="text"
                maxLength={41}
                value={formData?.currencyOther}
                autoComplete="off"
                placeholder={'Type here'}
                onChange={(event) => {
                  const { name, value } = event.target;
                  if (value?.length === 41) {
                    setErrorCurrencyOther(<span className="select-error-msg">Maximum 40/40 characters are allowed!</span>);
                  } else if (/^\s/.test(value)) {
                    setErrorCurrencyOther(<span className="select-error-msg">Cannot start with a space!</span>);
                  } else {
                    updateFormData({ ...formData, [name]: value });
                    setErrorCurrencyOther('');
                  }
                }}
              />
              {errorCurrencyOther && <span className="select-error-msg">{errorCurrencyOther}</span>}
            </Col>
          )}

          <Col xs="12" sm="6" md="6" lg="6" className={formData?.currency === 'Other' ? 'row-projects' : ''}>
            <Label>
              Billing Platform <span className="spanSteric">*</span>
            </Label>
            <Select
              name="Billing Platform"
              options={sortedOptions}
              value={sortedOptions?.find((opt) => opt?.value === formData?.billingPlateform)}
              placeholder={'Select billing platform'}
              onChange={(event) => {
                if (event && event.value) {
                  const { value } = event;
                  const specialPlatforms = ['UPWORK_PROFILE', 'PAYONEER_ACCOUNT', 'OTHER'];
                  const shouldClearBillingProfile = !specialPlatforms?.includes(value);
                  updateFormData({
                    ...formData,
                    billingPlateform: value,
                    ...(shouldClearBillingProfile && { billingProfile: null })
                  });
                }
              }}
              maxMenuHeight={120}
            />
            {errorBillingProfile && <span className="select-error-msg">{errorBillingProfile}</span>}
          </Col>
          {(formData?.billingPlateform === 'UPWORK_PROFILE' ||
            formData?.billingPlateform === 'PAYONEER_ACCOUNT' ||
            formData?.billingPlateform === 'OTHER') && (
              <Col xs="12" sm="6" md="6" lg="6" className="row-projects">
                <Label>
                  Billing Profile <span className="spanSteric">*</span>
                </Label>

                <Input
                  name="billingProfile"
                  className={errorBillingProfile ? 'select-error-border' : ''}
                  type="text"
                  maxLength={41}
                  value={formData?.billingProfile}
                  autoComplete="off"
                  placeholder={'Type here'}
                  onChange={(event) => {
                    const { name, value } = event.target;
                    if (value.length === 41) {
                      setErrorBillingProfile(<span className="select-error-msg">Maximum 40/40 characters are allowed!</span>);
                    } else if (/^\s/.test(value)) {
                      updateFormData({ ...formData, [name]: value.trimLeft() });
                      setErrorBillingProfile(<span className="select-error-msg">Cannot start with a space!</span>);
                    } else {
                      updateFormData({ ...formData, [name]: value });
                      setErrorBillingProfile('');
                    }
                  }}
                />
              </Col>
            )}
          <Col xs="12" sm="6" md="6" lg="6" className="row-projects">
            <Label>
              Company Name <span className="spanSteric">*</span>
            </Label>
            <Input
              name="clientCompanyName"
              className={errorCompanyName ? 'select-error-border' : ''}
              type="text"
              maxLength={51}
              value={formData?.clientCompanyName}
              autoComplete="off"
              placeholder={'Type here'}
              onChange={(event) => {
                const { name, value } = event.target;
                if (value.length === 51) {
                  setErrorCompanyName(<span className="select-error-msg">Maximum 50/50 characters are allowed!</span>);
                } else if (/^\s/.test(value)) {
                  updateFormData({ ...formData, [name]: value.trimLeft() });
                  setErrorCompanyName(<span className="select-error-msg">Cannot start with a space!</span>);
                } else {
                  updateFormData({ ...formData, [name]: value });
                  setErrorCompanyName('');
                }
              }}
              onKeyPress={(event) => {
                if (/[^a-zA-Z, ]/.test(event.key)) {
                  setErrorCompanyName(<span className="select-error-msg">Only alphabets are allowed!</span>);
                  event.preventDefault();
                }
              }}
            />
            {errorCompanyName && <span className="select-error-msg">{errorCompanyName}</span>}
          </Col>
        </Row>
        <Row className="row-projects"></Row>
      </div>
      {typeModal !== 'manage' && (
        <div className="btn_outer text-right d-flex justify-content-end align-items-center">
          <Button
            outline
            onClick={() => {
              stepper.previous(), setActive(active - 1);
            }}
            className="action_btn"
          >
            Back
          </Button>
          <Button
            disabled={isDisabled}
            color="primary"
            onClick={() => {
              stepper.next();
            }}
            className="action_btn"
          >
            Next
          </Button>
        </div>
      )}
    </>
  );
};
